var map = {
	"./icon-for-not-found.svg": 50208,
	"./icon_id_1.svg": 9331,
	"./icon_id_2.svg": 60009,
	"./icon_id_3.svg": 14795,
	"./icon_id_4.svg": 8487,
	"./icon_id_5.svg": 63056,
	"./icon_id_6.svg": 73230,
	"./icon_id_7.svg": 49366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33179;